__turbopack_context__.v({
  "contentHeader": "Layout-module-scss-module__ZtqNRq__contentHeader",
  "desktopGatewaySelector": "Layout-module-scss-module__ZtqNRq__desktopGatewaySelector",
  "gatewayErrorRecovery": "Layout-module-scss-module__ZtqNRq__gatewayErrorRecovery",
  "localGatewaySelectorBar": "Layout-module-scss-module__ZtqNRq__localGatewaySelectorBar",
  "localTopbar": "Layout-module-scss-module__ZtqNRq__localTopbar",
  "mobilePortalHeader": "Layout-module-scss-module__ZtqNRq__mobilePortalHeader",
});
